import { useLocation } from "react-router";
import { typedUrlForRoute } from "../PlatformRouter/RoutesDef";
import { HierarchicalLinksModule } from "./HierarchicalLinksModule";
import type { AppDrawerModuleItem } from "./AppDrawer-shared";
import type { IconName } from "@mdotm/shadcn/legacy/components";

export function AdminPanelModule() {
	return <HierarchicalLinksModule className="px-4" items={useAdminPanelItems()} />;
}

export function useAdminPanelItems(): AppDrawerModuleItem<"Global settings panel" | "Info">[] {
	const location = useLocation();

	return [
		{
			enabled: true,
			icon: "share" satisfies IconName,
			name: "Global settings panel",
			title: "Global settings panel",
			href: typedUrlForRoute("AdvanceSettings/UserSettingsPanel", {}),
			active: location.pathname.startsWith(typedUrlForRoute("AdvanceSettings/UserSettingsPanel", {})),
		},
		{
			enabled: true,
			icon: "Information" satisfies IconName,
			name: "Info",
			title: "Info",
			href: typedUrlForRoute("AdvanceSettings/PlatformInfo", {}),
			active: location.pathname.startsWith(typedUrlForRoute("AdvanceSettings/PlatformInfo", {})),
		},
	];
}
